// Reducer for homepage actions
import { saveAs } from 'file-saver'

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultBudgetSubscribersState = {
  quarters: null,
  selectedMetricDate: '',
  byMetricDate: {}
}

export const DefaulttBudgetSubscribersState = {
  ...DefaultState
}

export const budgetSubscribersDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_BUDGET_SUBSCRIBERS,
  actionFailure: ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_BUDGET_SUBSCRIBERS,
  actionInvalidate: ActionTypes.INVALIDATE_BUDGET_SUBSCRIBERS
})

export const budgetSubscribersQuarters = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultState,
  actionRequest: ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_QUARTERS,
  actionFailure: ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_QUARTERS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_BUDGET_SUBSCRIBERS_QUARTERS,
  actionInvalidate: ActionTypes.INVALIDATE_BUDGET_SUBSCRIBERS_QUARTERS
})

export const budgetSubscribersExport = (state = DefaulttBudgetSubscribersState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_EXPORT:
      return {
        ...state,
        isFetching: true
      }
    case ActionTypes.RECEIVE_BUDGET_SUBSCRIBERS_EXPORT:
      saveAs(action.response, action.filename)
      return {
        ...state,
        isFetching: false,
        lastUpdated: action.receivedAt
      }
    case ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_EXPORT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        lastUpdated: action.receivedAt
      }
    default:
      return state
  }
}

export const budgetSubscribersByMetricDate = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_BUDGET_SUBSCRIBERS:
    case ActionTypes.RECEIVE_BUDGET_SUBSCRIBERS:
    case ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_FAILURE:
    case ActionTypes.INVALIDATE_BUDGET_SUBSCRIBERS:
      return {
        ...state,
        budgetSubscribers: budgetSubscribersDetails(state.details, action)
      }
    default:
      return state
    }
}

export const budgetSubscribers = (state = DefaultBudgetSubscribersState, action) => {
  switch (action.type) {
    case ActionTypes.BUDGET_SUBSCRIBERS_SELECTED_QUARTER:
      return {
        ...state,
        selectedMetricDate: action.metricDate
      }
    case ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_QUARTERS:
    case ActionTypes.RECEIVE_BUDGET_SUBSCRIBERS_QUARTERS:
    case ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_QUARTERS_FAILURE:
    case ActionTypes.INVALIDATE_BUDGET_SUBSCRIBERS_QUARTERS:
      return {
        ...state,
        quarters: budgetSubscribersQuarters(state.details, action)
      }
    case ActionTypes.REQUEST_BUDGET_SUBSCRIBERS:
    case ActionTypes.RECEIVE_BUDGET_SUBSCRIBERS:
    case ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_FAILURE:
    case ActionTypes.INVALIDATE_BUDGET_SUBSCRIBERS:
      if (action.metricDate) {
        return {
          ...state,
          selectedMetricDate: action.metricDate,
          byMetricDate: {
            ...state.byMetricDate,
            [action.metricDate]: budgetSubscribersByMetricDate(state.byMetricDate[action.metricDate], action)
          }
        }
      } else {
        console.warn('Budget Subscribers action fired without a metric date:', action)
        return state
      }
    case ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_EXPORT:
    case ActionTypes.RECEIVE_BUDGET_SUBSCRIBERS_EXPORT:
    case ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_EXPORT_FAILURE:
      return {
        ...state,
        export: budgetSubscribersExport (state.export, action)
      }
    default:
      return state
    }
}